import React from 'react';
import { ChevronRight } from 'lucide-react';
import { TaraCard, TaraCardContent } from '../ui/TaraCard';

const IntelCard = ({ title, subtitle, value, icon, onClick }) => {
  return (
    <TaraCard 
      interactive={!!onClick}
      onClick={onClick}
      className="hover:shadow-md transition-all"
    >
      <TaraCardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 flex-1">
            {icon && (
              <div className="w-10 h-10 rounded-full bg-stone-100 flex items-center justify-center text-lg flex-shrink-0">
                {icon}
              </div>
            )}
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-stone-900 truncate">{title}</h3>
              {subtitle && (
                <p className="text-xs text-stone-600 truncate mt-0.5">{subtitle}</p>
              )}
            </div>
          </div>
          <div className="flex items-center gap-2 ml-3 flex-shrink-0">
            {value && (
              <span className="text-sm font-bold text-stone-900">{value}</span>
            )}
            {onClick && (
              <ChevronRight className="w-4 h-4 text-stone-400" />
            )}
          </div>
        </div>
      </TaraCardContent>
    </TaraCard>
  );
};

export default IntelCard;